module.exports = __webpack_public_path__ + "img/applycode.280c24ad.png";